import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/feature-flags')({
  staticData: { breadcrumb: 'Feature Flags' },
  component: () => <Outlet />,
});
